import { Facebook, Instagram, Youtube } from "lucide-react";
import { SOCIAL } from "../../data/content";

export const InstagramBanner = () => (
  <a
    data-testid="instagram-banner"
    href={SOCIAL.instagram}
    target="_blank"
    rel="noopener noreferrer"
    className="group block relative overflow-hidden border border-neutral-800 hover:border-red-600 bg-neutral-900 p-7 transition-colors"
  >
    <span
      aria-hidden
      className="absolute -right-10 -top-10 w-44 h-44 bg-red-600/10 rotate-12 group-hover:bg-red-600/20 transition-colors"
    />
    <div className="relative flex items-start gap-5">
      <span className="w-12 h-12 shrink-0 bg-red-600 flex items-center justify-center">
        <Instagram className="w-6 h-6 text-white" />
      </span>
      <div className="min-w-0">
        <div className="mono-label text-xs text-red-500 uppercase tracking-wider mb-1">
          Live dai paddock &bull; {SOCIAL.instagramHandle}
        </div>
        <h3 className="font-display text-xl sm:text-2xl font-black uppercase text-white leading-tight">
          Le foto delle gare sono su Instagram
        </h3>
        <p className="text-xs text-neutral-400 mt-2 leading-relaxed">
          Prove speciali, assistenza, raduni del Club e cantiere del Legend Village: seguici
          per non perdere nessuna tappa della stagione.
        </p>
        <div className="flex flex-wrap items-center gap-3 mt-5">
          <span className="px-5 py-2.5 bg-white text-black text-xs font-black uppercase tracking-widest group-hover:bg-red-600 group-hover:text-white transition-colors">
            Segui {SOCIAL.instagramHandle}
          </span>
          <span className="flex items-center gap-3 text-neutral-500">
            <Youtube className="w-4 h-4" />
            <Facebook className="w-4 h-4" />
            <span className="mono-label text-[10px] uppercase">Anche su YouTube e Facebook</span>
          </span>
        </div>
      </div>
    </div>
  </a>
);
